import { render } from "./IconText.vue?vue&type=template&id=208164e8&scoped=true"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"

import "./IconText.vue?vue&type=style&index=0&id=208164e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208164e8"]])

export default __exports__